import React from 'react'
import cn from 'classnames'
import classes from '../../Table.module.scss'

interface BodyCellProps {
  children?: React.ReactNode
  isSelected?: boolean
  className?: string
  spacing?: number
}

export const BodyCell = ({
  children,
  isSelected,
  className,
  spacing = 4,
}: BodyCellProps) => (
  <div
    role='cell'
    className={cn(
      `col-${spacing}`,
      'd-flex justify-content-center align-items-center mc-text--center',
      className,
      {
        [classes.selected]: isSelected,
      },
    )}
    aria-current={isSelected}
  >
    <BodyCellContent>{children}</BodyCellContent>
  </div>
)

const BodyCellContent = ({ children }: Pick<BodyCellProps, 'children'>) => {
  if (!children) return null

  return <div className='mc-pt-2 mc-w-100'>{children}</div>
}
